export class CopyPricingSchemeDto{
    source_guid: string;
    destination_guid: string;

    salesTaxConfig: string;
    salesTaxRate: number;
    salesTaxCheckbox: boolean;

    salesUnitPrice: number;
    salesUnitPriceOperator: string;
    salesUnitPriceCheck: boolean;

    salesMinPrice:number;
    salesMinPriceOperator: string;
    salesMinPriceCheck: boolean;

    salesMaxPrice: number;
    salesMaxPriceOperator: string;
    salesMaxPriceCheck: boolean;

    salesUnitPriceBeforeDiscount: number;
    salesUnitPriceBeforeDiscountOperator: string;
    salesUnitPriceBeforeDiscountCheck: boolean;

    purchaseTaxConfig: string;
    purchaseTaxRate: number;
    purchaseTaxCheckbox: boolean;

    purchaseUnitPrice: number;
    purchaseUnitPriceOperator: string;
    purchaseUnitPriceCheck: boolean;

    purchaseMinPrice: number;
    purchaseMinPriceOperator: string;
    purchaseMinPriceCheck: boolean;

    purchaseMaxPrice: number;
    purchaseMaxPriceOperator: string;
    purchaseMaxPriceCheck: boolean;
}